<template>
    <v-card style="border-radius: 1em;" class="pa-3">
        <v-card-title>
          <h2 style="text-align: center; width: 100%;">Cadastre um novo meio de recebimento</h2>
        </v-card-title>
        <v-card-text>
            <v-select
              v-model="item_selecionado"
              item-text="descricao"
              :items="lista"
              return-object
              label="Selecione uma meio de recebimento"
            />
            <h2 v-if="item_selecionado && item_selecionado.id < 4" class="text-xs-certer mb-2">{{item_selecionado.descricao}}</h2>
            <v-layout column v-if="item_selecionado !== undefined && item_selecionado.id == 1">
            <h4 style="width: 100%; text-align: left;"> Tipo de chave pix: </h4>
            <v-radio-group
              v-model="tipo_chave_pix"
              column
            >
              <v-radio
                label="CPF"
                value="cpf"
              ></v-radio>
              <v-radio
                label="CNPJ"
                value="cnpj"
              ></v-radio>
              <v-radio
                label="Email"
                value="email"
              ></v-radio>
              <v-radio
                label="Telefone"
                value="telefone"
              ></v-radio>
              <v-radio
                label="Chave aleatória"
                value="key"
              ></v-radio>
            </v-radio-group>
              <v-text-field
                  :disabled="!tipo_chave_pix"
                  label="Digite sua chave pix"
                  :mask="getmask(tipo_chave_pix)"
                  v-model="chave_pix"
              ></v-text-field>
            </v-layout>
            <v-layout column v-if="item_selecionado !== undefined && item_selecionado.id == 2">
              <v-flex xs12>
                <v-select
                ref="select_banco"
                v-model="selectdBanco"
                :items="bancos"
                label="Selecione o banco"
                required=false
              ></v-select>
              </v-flex>
              <v-flex xs12>
              <v-text-field
                  ref="num_agencia"
                  label="Informe a agência"
                  v-model="num_agencia"
                  required=false
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
              <v-text-field
                  ref="num_conta"
                  label="Informe o número da conta com o digito"
                  v-model="num_conta"
                  required=false
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                ref="select_conta"
                v-model="selectdConta"
                :items="tipos_conta"
                item-text="descricao"
                item-value="id"
                label="Selecione o tipo de conta"
                required=false
              ></v-select>
              </v-flex>
            </v-layout>
             <v-layout column v-if="item_selecionado !== undefined && item_selecionado.id == 3">
               <v-text-field
                  ref="cod_barras"
                  label="Didite o código de barras do boleto"
                  v-model="cod_barras"
                ></v-text-field>
             </v-layout>
        </v-card-text>
        <v-card-actions class="justify-space-around">
          <v-btn round @click="fechar" class="mb-2">
            Voltar
          </v-btn>
          <v-btn round class="mb-2" :disabled="is_disabled()" @click="cadastrarMeioRecebimento" color="primary">
            Salvar
          </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  data () {
    return {
      item_selecionado: undefined,
      chave_pix: undefined,
      tipo_chave_pix: undefined,
      num_agencia: undefined,
      num_conta: undefined,
      selectdConta: undefined,
      selectdBanco: undefined,
      cod_barras: undefined,
      lista: [
        { id: 1, descricao: 'Transferência (PIX)' },
        { id: 2, descricao: 'Transferência (TED)' },
        { id: 3, descricao: 'Boleto bancário' },
        { id: 4, descricao: 'Cartão de Crédito' },
        { id: 5, descricao: 'Cartão de Débito' }
      ],
      bancos: [
        'Banco Itaú Unibanco',
        'Banco do Brasil',
        'Caixa Econômica Federal',
        'Banco Bradesco',
        'Banco Santander Brasil',
        'Banrisul',
        'Banco do Nordeste',
        'Sicoob',
        'Nubank',
        'Bancon Inter',
        'Neon',
        'Next',
        'Outro'
      ],
      tipos_conta: [
        { descricao: 'Conta Corrente', 'id': 1 },
        { descricao: 'Conta Poupança', 'id': 2 },
        { descricao: 'Conta Conjunta', 'id': 3 },
        { descricao: 'Conta Salário', 'id': 4 }
      ]
    }
  },
  methods: {
    is_disabled () {
      if (!this.item_selecionado) return true
      else if (this.item_selecionado.id === 1 && (!this.tipo_chave_pix || !this.chave_pix)) return true
      else if (this.item_selecionado.id === 2 && (!this.num_agencia || !this.num_conta || !this.selectdBanco || !this.selectdConta)) return true
      else if (this.item_selecionado.id === 3 && !this.cod_barras) return true
      return false
    },
    fechar () {
      this.item_selecionado = undefined
      this.chave_pix = undefined
      this.num_agencia = undefined
      this.num_conta = undefined
      this.selectdConta = undefined
      this.selectdBanco = undefined
      this.cod_barras = undefined
      this.$emit('fechar')
    },
    cadastrarMeioRecebimento () {
      this.$store.dispatch('meioRecebimentoApetrus', {
        tipo: this.item_selecionado.id,
        descricao: this.item_selecionado.descricao,
        chave_pix: this.chave_pix ? this.chave_pix : null,
        cod_boleto: this.cod_barras ? this.cod_barras : null,
        banco: this.selectdBanco ? this.selectdBanco : null,
        agencia: this.num_agencia ? this.num_agencia : null,
        conta: this.num_conta ? this.num_conta : null,
        tipo_conta: this.selectdConta ? this.selectdConta : null,
        is_apetrus: true,
        method: 'POST'
      }).then(() => {
        this.$emit('carregarMeios')
        this.fechar()
      })
    },
    getmask (tipo) {
      if (tipo === 'cpf') {
        return '###.###.###-##'
      } else if (tipo === 'cnpj') {
        return '##.###.###/####-##'
      } else if (tipo === 'telefone') {
        return '+55 (##)#####-####'
      }
    }
  },
  watch: {
    item_selecionado (val) {
      this.chave_pix = undefined
      this.num_agencia = undefined
      this.num_conta = undefined
      this.selectdConta = undefined
      this.selectdBanco = undefined
      this.cod_barras = undefined
    }
  }
}
</script>
